import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Contact from "../pages/Contact";
import Male from "../pages/Male";
import Female from "../pages/Female";
import Home3 from "../pages/Home3";
import Ab from "../pages/Ab";
import Blog from "../pages/Blog";
import Our from "../pages/Our";

const Routers = () => {
  const savedGender = localStorage.getItem("fitness_gender"); // "male" | "female" | null

  return (
    <Routes>
      {/* Default Route */}
      <Route
        path="/"
        element={
          savedGender === "male" ? (
            <Navigate to="/Male" replace />
          ) : savedGender === "female" ? (
            <Navigate to="/Female" replace />
          ) : (
            <Navigate to="/Home3" replace />
          )
        }
      />

      {/* Main Pages */}
      <Route path="/Home3" element={<Home3 />} />
      <Route path="/Male" element={<Male />} />
      <Route path="/Female" element={<Female />} />

      {/* Other Pages */}
      <Route path="/aboutus" element={<Ab />} />
      <Route path="/our-programs" element={<Our />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/Blog" element={<Blog />} />

      {/* Not Found */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Routers;
